import { render } from "./Forgotpw.vue?vue&type=template&id=a5b8d6a4&scoped=true"
import script from "./Forgotpw.vue?vue&type=script&lang=js"
export * from "./Forgotpw.vue?vue&type=script&lang=js"

import "./Forgotpw.vue?vue&type=style&index=0&id=a5b8d6a4&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b8d6a4"]])

export default __exports__